<template>
  <div class="flex w-full items-center p-4 gap-3">
    <Button color="text-b-b" size="md" class="w-full h-10" @click="emit('click-forgot')">
      <Icon icon="Function-Wireframe-Password" class="size-5" />
      {{ $t('home.user.loginForm.forget') }}
    </Button>
    <Button color="text-b-b" size="md" class="w-full h-10" @click="emit('click-register')">
      <Icon icon="Function-Wireframe-User" class="size-5" />
      {{ $t('home.user.registerForm.register') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
  import { Button, Icon } from '@rapoo/element'

  const emit = defineEmits<{
    (e: 'click-forgot'): void
    (e: 'click-register'): void
  }>()
</script>
